module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/leromain.52c6411.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/leromain.jpg
// module id = Gaiz
// module chunks = 0